import {useDebugValue} from 'react';

import {undef, runSLPDatePickerOpenedExperiment} from '../../../utils';

import {useSettings} from './';

const defaultDatesSettings = {
    isOpen: false,
    readOnly: false,
    showContinueButton: true
};

function useDatesSettings(props, systemOptions, abacusStore) {
    const {
        datesSettings: propsDatesSettings
    } = props;

    const overrideDatesSettings = {
        isOpen: runSLPDatePickerOpenedExperiment(abacusStore, systemOptions) || undef
    };

    const {
        initialSettings: initialDatesSettings,
        settings: datesSettings,
        changeSettings: changeDatesSettings
    } = useSettings(defaultDatesSettings, propsDatesSettings, overrideDatesSettings);

    const result = {
        initialDatesSettings,
        datesSettings,
        changeDatesSettings
    };

    useDebugValue(result);

    return result;
}

export {useDatesSettings};
